import { Scene, FullScreenBackgroundFill } from "onearm";
import { Signal } from "typed-signals";

export class AutoPlaySettingsScene extends Scene {
    constructor(parameters) {
        super({ layer: "popups", name: "AutoPlaySettingsScene", ...parameters });
    }

    create(options) {
        super.create(options);

        const {
            screen,
            gamesLimit = 10,
            autoplayGamesMax = 100,
        } = options;

        this.onPressClose = new Signal();
        this.onPressStart = new Signal();
        this.onChangeAutoplayGames = new Signal();

        this.fill = this.addChildAt(
            new FullScreenBackgroundFill({
                fullScreenZone: screen.zone.fullScreen,
                color: 0x000000,
                alpha: 0.8,
            }),
        0);

        this._currentValue = gamesLimit;

        this.layout.forAll("CloseButton", (btn) => {
            btn.onPress.connect(() => this.onPressClose.emit());
        });

        this.layout.forAll("StartAutoplayButton", (btn) => {
            btn.onPress.connect(() => this.onPressStart.emit(this._currentValue));
        });

        this.layout.forAll("ValueSlider", (slider) => {
            slider.setSteps(
                { min: 1, max: autoplayGamesMax, step: 1 },
                gamesLimit,
            );
            slider.onUpdate.connect((value) => {
                this._currentValue = value;
                this.updateStartAutoplayText(value);
            });
            slider.onChange.connect((value) => {
                this._currentValue = value;
                this.onChangeAutoplayGames.emit(value);
            });
        });

        this.updateStartAutoplayText(gamesLimit);
    }

    updateStartAutoplayText(value) {
        this.layout.forAll("StartAutoplayText", (text) => {
            text.text = `START AUTOPLAY (${value})`;
        });
    }
}
